
import Sounds         from '@/entities/Sounds'
import SoundDebounced from '@/entities/Sound/Debounced'
import Settings       from '@/entities/Settings'

STATUS_AWAIT   = 'await'
STATUS_PREPARE = 'prepare'
STATUS_ROUND   = 'round'
STATUS_PAUSE   = 'pause'
STATUS_REST    = 'rest'
STATUS_DONE    = 'done'

STATUSES_WITH_SOUND = [
  STATUS_PREPARE
  STATUS_ROUND
  STATUS_REST
  STATUS_DONE
]

export default class

  # properties                Properties
  # onStatusChangedListener
  #
  # prepareSound              Sound/Debounced
  #
  # status
  # currentRound
  # statusSetAt
  # sounds

  constructor: (@properties, @onStatusChangedListener) ->
    @status       = STATUS_AWAIT
    @currentRound = 1
    @statusSetAt  = null
    @sounds       = new Sounds()
    @prepareSound = new SoundDebounced @sounds.getRestDone(), 1.5

  startStop: ->
    if @status == STATUS_AWAIT then return @_setStatus STATUS_PREPARE
    if @status == STATUS_DONE  then return
    return @_setStatus STATUS_PAUSE

  _setStatus: (@status) ->
    @onStatusChangedListener @status
    @statusSetAt = Date.now()
    if STATUSES_WITH_SOUND.includes @status then @sounds.playGong @properties.getGongVolume()
    return @_updateState()

  # × · •
  getRounds: -> "#{ @currentRound } • #{ @properties.getRounds() }"

  isActive:     -> @status != STATUS_PAUSE && @status != STATUS_DONE
  isStatusDone: -> @status == STATUS_DONE

  _calcRemain: (duration) -> duration - (Date.now() - @statusSetAt) / 1000

  # return remain time
  _updateState: ->
    if @status == STATUS_AWAIT then return @properties.getRoundTime()
    if @status == STATUS_PREPARE
      remain = @_calcRemain Settings.getFirstRoundPrepareTime()
      if remain < Settings.getRemainForSwitch() then return @_setStatus STATUS_ROUND
    if @status == STATUS_ROUND
      remain = @_calcRemain @properties.getRoundTime()
      if remain < Settings.getRemainForSwitch() then return @_setStatus @currentRound >= @properties.getRounds() && STATUS_DONE || STATUS_REST
    if @status == STATUS_REST
      remain = @_calcRemain @properties.getRestTime()
      if remain < Settings.getRemainForSwitch()
        @currentRound++
        return @_setStatus STATUS_ROUND
    if @status == STATUS_DONE  then return 0
    if @status == STATUS_PAUSE then return 0
    return remain

  _twoChar: (value) ->
    value = "#{ Math.floor value }"
    return value.padStart 2, '0'

  getRemain: ->
    remain = @_updateState()
    # console.log 'currentRound', @currentRound, 'status', @status, 'remain', remain
    a remain != null, "remain unknown, status: #{ @status }"
    a remain >= 0, "remain invalid: #{ remain }"
    if @status == STATUS_PREPARE || @status == STATUS_REST
      [ from, to ] = Settings.getRemainForPlayPrepareSound()
      from <= remain && remain <= to && @prepareSound.play @properties.getRestDoneVolume()
    minutes = Math.floor remain / 60
    return "#{ minutes }:#{ @_twoChar remain % 60 }"
